export default "__VITE_ASSET__Bp755uDd__"